const PhoneIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="10px"
    height="10px"
    viewBox="0 0 100 100"
  >
    <path
      d="M37 13.7S30.5.5 23.4 5.4s-20.1 17.4-13 39.4 36 46.7 46.5 48.8 20.2 3.5 30.5-6.5 2-14.4-2.5-18.2c-4.5-3.8-11.3-10.3-18.9-3.7-7.6 6.6-9.8 9.6-19.5 1.3S26 43.1 31.8 37.5s15.6-8.6 5.2-23.8z"
    />
  </svg>
);

export default PhoneIcon;
